import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <div className="relative group order-2 md:order-1">
            <div className="absolute inset-0 bg-gradient-to-tr from-red-600/20 to-blue-600/20 rounded-2xl transform group-hover:scale-105 transition-transform duration-500" />
            <img
              src="https://customer-assets.emergentagent.com/job_e2580245-7f60-4bc0-a2e4-cf3b7d2c93e3/artifacts/hkhp5fqq_c00cf60d-577e-45da-92d0-fd356dbc8778.jpeg"
              alt="Tomás Roco Profile"
              className="relative rounded-2xl shadow-2xl w-full h-[600px] object-cover"
            />
          </div>

          {/* Content */}
          <div className="order-1 md:order-2">
            <h2
              className="text-5xl md:text-6xl font-bold mb-4 tracking-wide"
              style={{ fontFamily: 'Bebas Neue, sans-serif' }}
            >
              {t.about.title}
            </h2>
            <div className="h-1 w-20 bg-red-600 mb-8" />
            
            <h3
              className="text-2xl font-semibold mb-6 text-gray-300"
              style={{ fontFamily: 'Oswald, sans-serif' }}
            >
              {t.about.subtitle}
            </h3>
            
            <div className="space-y-4 text-gray-400 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
              <p className="text-lg">{t.about.bio1}</p>
              <p className="text-lg">{t.about.bio2}</p>
              <p className="text-lg">{t.about.bio3}</p>
              <p className="text-lg font-semibold text-white">{t.about.bio4}</p>
            </div>
          </div>
        </div>

        {/* Player Profile Section */}
        <div className="mt-20">
          <h3
            className="text-4xl md:text-5xl font-bold mb-4 text-center tracking-wide"
            style={{ fontFamily: 'Bebas Neue, sans-serif' }}
          >
            {t.playerProfile.title}
          </h3>
          <div className="h-1 w-20 bg-red-600 mx-auto mb-8" />
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {t.playerProfile.attributes.map((attribute, index) => (
              <div
                key={index}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4 text-center hover:border-red-600/50 transition-all duration-300 hover:transform hover:-translate-y-1"
              >
                <p 
                  className="text-white font-semibold"
                  style={{ fontFamily: 'Poppins, sans-serif' }}
                >
                  {attribute}
                </p>
              </div>
            ))}
          </div>

          <p
            className="text-center text-gray-300 text-lg italic max-w-3xl mx-auto"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            👉 {t.playerProfile.subtitle}
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
